import { FormControlProps } from '../../../FormControl';

export enum Format {
  Seconds = 'seconds',
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Formatted = 'formatted'
}

export default interface DurationInputProps {
  /** Number of milliseconds value for controlled input. */
  value?: number;
  /** Number of milliseconds value for uncontrolled input.
   * @default 0
   */
  defaultValue?: number;
  /**
   * Sets the duration format.
   * @default seconds
   */
  format?: Format;
  /** Callback fired on lost focus of the input field. */
  onChange?: (value: number | undefined) => void;
  /** Callback fired after new format option selected. */
  onSelect?: (value: Format) => void;
  /**
   * Sets DOM id for the control and associates label element via 'for' attribute.
   * If an id is not pass, a random id will be generated for any render.
   */
  id?: FormControlProps['id'];
  /** Set visual state based on a validation state. */
  status?: FormControlProps['status'];
  /** Pass a string or a fragment with an Icon and string. */
  label?: FormControlProps['label'];
  /** Visually hides the label region. */
  labelHidden?: FormControlProps['labelHidden'];
  /** It is recommended to pass a simple string to offer guidance. Text will be styled based on status prop. */
  info?: FormControlProps['info'];
  /** Indicate if the field is required. The browser defaults to false. */
  required?: FormControlProps['required'];
  /** Disable the control. The browser defaults to false. */
  disabled?: FormControlProps['disabled'];
  /** Makes the input non editable and non clickable. The browser defaults to false. */
  readOnly?: FormControlProps['readOnly'];
  /** Sets html name attribute for the underlying control. Useful for mapping to a data field. */
  name?: FormControlProps['name'];
  /** Automatically focuses the input on render. */
  autoFocus?: boolean;
}
